import { useEffect } from "react";
import { useSiteTheme } from "components/SiteTheme";
import { Segmented } from "./Effects";

const THEMES = [
  { value: "system", label: "Auto" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

// Hides the public site's floating theme pill while an app shell is mounted.
export function useClaimThemeControl() {
  const claim = useSiteTheme()?.claimThemeControl;
  useEffect(() => (claim ? claim() : undefined), [claim]);
}

export function Switch({ checked, onChange, children }) {
  return (
    <button type="button" role="switch" aria-checked={checked} className="ios-switch-row" onClick={() => onChange(!checked)}>
      <span>{children}</span>
      <span className="ios-switch" aria-hidden="true" />
    </button>
  );
}

export function AppearanceControls({ effects, setEffects }) {
  const theme = useSiteTheme();
  return (
    <div className="ios-appearance">
      <Segmented label="Appearance" items={THEMES} value={theme?.preference || "system"} onChange={(v) => theme?.select(v)} glass={null} />
      <Switch checked={effects === "on"} onChange={(on) => setEffects(on ? "on" : "off")}>Glass effects</Switch>
    </div>
  );
}
